<template>
  <div class="action-page pt-3">
    <div class="container ms-13 me-13">
      <nav class="d-flex align-cente justify-space-between">
        <div class="head-logo d-flex justify-center flex-column">
          <h2>Good Morning</h2>
          <h3>Franklin Bennedict</h3>
        </div>
        <ul class="d-flex align-center ga-10">
          <li>
            <a
              :class="{ 'text-red': ActiveLink === 'all-items' }"
              @click.prevent="setActiveLink('all-items')"
              href="#"
              >All Items</a
            >
          </li>
          <li>
            <a
              :class="{ 'text-red': ActiveLink === 'snoozed' }"
              @click.prevent="setActiveLink('snoozed')"
              href="#"
              >Snoozed</a
            >
          </li>
          <li>
            <a
              :class="{ 'text-red': ActiveLink === 'email-me' }"
              @click.prevent="setActiveLink('email-me')"
              href="#"
              >Email Me</a
            >
          </li>
          <li>
            <a
              :class="{ 'text-red': ActiveLink === 'export' }"
              @click.prevent="setActiveLink('export')"
              href="#"
              >Export</a
            >
          </li>
        </ul>
      </nav>
      <div class="search-box">
        <div class="search-input">
          <input type="search" />
          <div class="search-icon">
            <img :src="require('../assets/image/search.png')" alt="search-icon" />
          </div>
        </div>
        <div class="d-flex ga-3">
          <button>
            <img :src="require('../assets/image/filter-icon.svg')" alt="filter-icon" />
          </button>
          <button>
            <img :src="require('../assets/image/dwonload-icon.svg')" alt="dwonload-icon" />
          </button>
        </div>
      </div>
      <v-row class="mt-8 d-flex justify-space-between ga-4">
        <v-col cols="3" class="day-box">
          <h2>Days Old</h2>
          <div class="d-flex justify-space-between mt-4 mb-1 flex-wrap">
            <button class="day-btn">
              <p>1 Day</p>
              <span>33</span>
            </button>
            <button class="day-btn">
              <p>2 Day</p>
              <span>33</span>
            </button>
            <button class="day-btn">
              <p>5 Day</p>
              <span>33</span>
            </button>
            <button class="day-btn">
              <p>10 Day</p>
              <span>33</span>
            </button>
            <button class="day-btn">
              <p>15 Day</p>
              <span>33</span>
            </button>
            <button block class="day-btn">
              <p>15 Day</p>
              <span>33</span>
            </button>
          </div>
          <h2>Priority</h2>
          <div class="d-flex justify-space-between mt-4 mb-1 flex-wrap">
            <button class="day-btn">
              <p>High</p>
              <span>33</span>
            </button>
            <button class="day-btn">
              <p>Medium</p>
              <span>33</span>
            </button>
            <button block class="day-btn">
              <p>Low</p>
              <span>33</span>
            </button>
          </div>
          <h2>Next Action</h2>
          <div class="d-flex mt-3 justify-space-between tap-view-btn align-center">
            <button style="background-color: #0c5df3" class="action-btn">vs</button>
            <button style="background-color: #f30c9f" class="action-btn">vs</button>
            <button style="background-color: #34a911" class="action-btn">vs</button>
            <button style="background-color: #aba610" class="action-btn">vs</button>
            <button style="background-color: #8f0cf3" class="action-btn">vs</button>
          </div>
        </v-col>
        <v-col cols="" class="Comments-section pb-16">
          <div class="pa-6 mobile-top">
            <div class="comments-nav d-flex align-center justify-space-between">
              <div class="d-flex replid-box align-center ga-4">
                <h2>#SYN-100234</h2>
                <h2>|</h2>
                <h2>Accessory Head Quarters</h2>
                <button class="replied-btn">Replied</button>
              </div>
              <div class="notification d-flex align-center ga-3">
                <button>
                  <img
                    :src="require('../assets/image/notification-icon.svg')"
                    alt="notification-icon"
                  />
                </button>
                <button>
                  <img :src="require('../assets/image/comments-icon.svg')" alt="comments-icon" />
                </button>
              </div>
            </div>
            <div class="mt-2 batch-text">
              <h3>
                FW: Batch # 4000129 - Marshall'S - Ship Start Date: 12/20/24 - Cancel Date: 12/27/24
              </h3>
              <h4 class="mt-3">Can you please send over carton labels thru PDF?</h4>
            </div>
            <div class="user d-flex align-center justify-space-between mt-4 mr-16">
              <h2 class="d-flex align-center ga-3"><button>VS</button>Velayutham Sankaran</h2>
              <div class="d-flex ga-3">
                <p>12-12-2024 7:50 PM</p>
                <p>10 days Old</p>
              </div>
              <h2 class="d-flex align-center ga-3">
                <button class="">VS</button>Velayutham Sankaran
              </h2>
            </div>
            <div class="mobile-user align-center">
              <h2 class="d-flex align-center ga-1"><button>VS</button>Velayutham Sankaran</h2>
              <h2 class="d-flex align-center ga-1"><button>VS</button>Velayutham Sankaran</h2>
            </div>
            <div class="mobile-time">
              <div>
                <h2>Assigned on</h2>
                <h3>12-12-2024 7:50 PM</h3>
              </div>
              <div class="d-flex ga-3">
                <button>
                  <img
                    :src="require('../assets/image/notification-icon.svg')"
                    alt="notification-icon"
                  />
                </button>
                <button>
                  <img :src="require('../assets/image/comments-icon.svg')" alt="comments-icon" />
                </button>
              </div>
            </div>
          </div>
          <hr />
          <div class="pa-6 comment-box">
            <h2>Comments</h2>
            <textarea class="w-full text-fill"></textarea>
            <div class="d-flex align-center ga-3 mt-4">
              <v-btn style="background-color: #dd0e1a; color: #ffffff; width: 85px">Save</v-btn>
              <v-btn style="background-color: #c9c9c9; color: #000000; width: 85px">Cancel</v-btn>
              <v-btn style="background-color: #c9c9c9; color: #000000; width: 85px">Attach</v-btn>
            </div>
            <div class="mobile-comment-box mt-6">
              <h2 class="d-flex align-center ga-3 mb-1">
                <button class="">VS</button>Velayutham Sankaran
              </h2>
              <h3 class="date">12/12/2024 07:50 PM</h3>
            </div>
            <textarea
              class="text-comment"
              placeholder="Do you have any carton labels template "
            ></textarea>
            <div class="mobile-text-area">
              <div class="mobile-comment-box mt-6">
                <h2 class="d-flex align-center ga-3 mb-1">
                  <button class="">VS</button>Velayutham Sankaran
                </h2>
                <h3 class="date">12/12/2024 07:50 PM</h3>
              </div>
              <textarea
                class="text-comment"
                placeholder="Do you have any carton labels template "
              ></textarea>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  components: {},

  data() {
    return {
      ActiveLink: "all-items",
    };
  },
  methods: {
    setActiveLink(link) {
      this.ActiveLink = link;
    },
  },
};
</script>
<style scoped>
.action-page {
  font-family: Quicksand !important;
  background-color: #ffffff;
}
nav {
  color: #000000;
}
nav h2 {
  font-size: 12px;
  line-height: 24px;
  font-weight: 300;
}
nav h3 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}
nav li {
  list-style: none;
}
nav a {
  text-decoration: none;
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  color: #000000;
  transition: all 0.3s;
}
nav .text-red {
  color: #dd0e1a;
}
.search-box {
  display: none;
}
.day-box {
  background-color: #efefef;
  border-radius: 12px;
  border: 1px solid #dfdfdf;
  width: 300px !important;
}
.day-box h2 {
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
}
.day-btn {
  display: flex;
  align-items: center;
  justify-content: space-between !important;
  width: 134px;
  border-radius: 4px;
  background-color: #e0e0e0;
  border: 1px solid #c9c9c9;
  box-shadow: none;
  text-transform: none !important;
  margin-bottom: 13px;
  padding: 8px;
}
.day-btn p {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: #000000;
}
.day-btn span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 4px;
  width: 24px;
  height: 24px;
  color: #000000;
  background-color: #fdd9db;
  border-radius: 50%;
  border: 1px solid #ffbcc0;
}
.action-btn {
  width: 42px;
  height: 42px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 0 !important;
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
}
.Comments-section {
  background-color: #efefef;
  border-radius: 12px;
  border: 1px solid #dfdfdf;
  padding: 0;
}
.Comments-section .comments-nav h2 {
  font-size: 14px;
  font-weight: 600;
  color: #b5b2b2;
}
.Comments-section .comments-nav .replied-btn {
  padding-inline: 8px;
  padding-block: 2px;
  font-size: 12px;
  line-height: 24px;
  font-weight: 600;
  color: #ffffff;
  border-radius: 4px;
  background-color: #34a911;
}
.Comments-section .batch-text h3 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
}
.Comments-section .batch-text h4 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
}
.Comments-section .user h2 {
  font-size: 14px;
  font-weight: 32px;
}
.Comments-section .user button {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  width: 32px;
  height: 32px;
  color: #ffffff;
  background-color: #0c5df3;
  border-radius: 50%;
}
.Comments-section .mobile-user {
  display: none;
}
.Comments-section .mobile-time {
  display: none;
}
.Comments-section .user p {
  font-size: 14px;
  font-weight: 600;
  color: #b5b2b2;
}
.Comments-section hr {
  margin-top: 8px;
  width: 100%;
  height: 1px;
  background-color: #b5b2b2;
  border: none;
}
.comment-box h2 {
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 11px;
}
.comment-box .text-fill {
  width: 100% !important;
  height: 90px !important;
  padding: 10px;
  border: none;
  background-color: #ffffff;
  border-radius: 4px;
}
.comment-box .text-fill:focus-visible {
  outline: none;
}
.comment-box h2 {
  font-size: 14px;
  font-weight: 32px;
}
.comment-box .date {
  display: none;
}
.comment-box h2 button {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  width: 32px;
  height: 32px;
  color: #ffffff;
  background-color: #0c5df3;
  border-radius: 50%;
}
.comment-box .text-comment {
  width: 100% !important;
  height: 56px !important;
  padding: 10px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  border: none;
  background-color: #ffffff;
  border-radius: 4px;
}
.comment-box .text-comment:focus-visible {
  outline: none;
}
.comment-box .mobile-text-area {
  display: none;
}
@media screen and (max-width: 1020px) {
  .tap-view-btn {
    gap: 20px;
    justify-content: center;
    flex-wrap: wrap;
  }
  .user {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 600px) {
  .container {
    margin-inline: 24px !important;
  }
  nav .head-logo {
    display: none !important;
  }
  nav ul {
    gap: 16px !important;
  }
  .search-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
  }
  .search-box .search-input {
    position: relative;
    width: 70%;
  }
  .search-box input {
    border: 1px solid #b7b6b6;
    background-color: #ebeaea;
    width: 100%;
    height: 36px;
    padding-left: 30px;
    font-size: 12px;
    font-weight: 400;
    border-radius: 4px;
  }
  .search-box input:focus-visible {
    outline: none;
  }
  .search-box .search-icon {
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    left: 6px;
  }
  .day-box {
    display: none;
  }
  .notification {
    display: none !important;
  }

  .replid-box {
    width: 100%;
    gap: inherit !important;
    justify-content: space-between !important;
  }
  .batch-text h3 {
    display: none;
  }
  .user {
    display: none !important;
  }
  .mobile-user {
    display: flex !important;
    gap: 10px;
    margin-block: 20px;
  }
  .mobile-user h2 {
    font-size: 10px;
    line-height: 22px;
  }
  .comment-box {
    padding-top: 0 !important;
  }
  .mobile-user h2 button {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    font-weight: 400;
    width: 18px;
    height: 18px;
    background-color: #0c5df3;
    color: #ffffff;
    border-radius: 50%;
  }
  .Comments-section hr {
    display: none;
  }
  .Comments-section .mobile-time {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .Comments-section .mobile-time h2 {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: #b5b2b2;
  }
  .Comments-section .mobile-time h3 {
    font-size: 14px;
    font-weight: 600;
    color: #000000;
  }
  .mobile-comment-box h2 {
    font-size: 12px;
    font-weight: 600;
  }
  .mobile-comment-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .mobile-comment-box h2 button {
    width: 18px;
    height: 18px;
    font-size: 8px;
    font-weight: 400;
  }
  .mobile-comment-box .date {
    display: inline;
    font-size: 12px;
    font-weight: 400;
    color: #b5b2b2;
  }
  .comment-box .mobile-text-area {
    display: block;
  }
}
</style>
